import config from '../config';

/**
 * Resolve CRM customer id from phone (same path as CallManagerMemberPanel / New Booking prefill).
 */
export async function resolveCustomerIdByPhone(phone, authHeaders = {}) {
  const digits = String(phone || '').replace(/\D/g, '');
  const query = digits.length >= 10 ? digits.slice(-10) : digits;
  if (!query) return null;

  const token = localStorage.getItem('token') || 'mock-jwt-token-for-testing';
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    ...authHeaders,
  };

  try {
    const searchRes = await fetch(
      `${config.customerApiBase}/users/search?query=${encodeURIComponent(query)}`,
      { headers },
    );
    if (!searchRes.ok) return null;
    const searchData = await searchRes.json();
    const user = (searchData?.users || [])[0];
    if (!user?.id) return null;

    const custRes = await fetch(`${config.customerApiBase}/users/${user.id}/customer`, {
      headers,
    });
    if (!custRes.ok) return null;
    const custData = await custRes.json();
    const cid = Number(custData?.customer_id);
    return Number.isFinite(cid) && cid > 0 ? cid : null;
  } catch {
    return null;
  }
}

export function memberCustomerId(member) {
  const direct = Number(member?.customer_id ?? member?.customerId);
  return Number.isFinite(direct) && direct > 0 ? direct : null;
}
